// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Test Case detail / Test Data / Reorder — theme-aware surfaces */

/* Reorder lists */
.rt-reorder-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.rt-reorder-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 10px;
  cursor: grab;
  color: var(--text-primary);
}

.rt-reorder-row:active {
  cursor: grabbing;
}

.rt-reorder-handle {
  color: var(--text-secondary);
  letter-spacing: -2px;
  font-size: 14px;
  -webkit-user-select: none;
          user-select: none;
}

.rt-reorder-row__title {
  font-weight: 600;
  font-size: 0.95rem;
}

.rt-reorder-row__meta {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-top: 4px;
  font-size: 0.8rem;
  color: var(--text-secondary);
}

.rt-reorder-list .drop-indicator {
  height: 3px;
  background: var(--primary, #3b82f6);
  border-radius: 2px;
  margin: 2px 0;
}

.rt-reorder-list .dragging {
  opacity: 0.55;
}

/* Test Data tab */
.test-data-tab {
  display: flex;
  flex-direction: column;
  gap: 20px;
  color: var(--text-primary);
}

.td-section {
  background: var(--bg-tertiary, var(--surface-hover));
  padding: 16px;
  border-radius: 10px;
  border: 1px solid var(--border);
}

.td-section__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.td-section__title {
  margin: 0 0 4px;
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--text-primary);
}

.td-section__hint {
  margin: 0;
  font-size: 0.85rem;
  color: var(--text-secondary);
}

.td-btn {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.9rem;
  font-weight: 500;
  transition: opacity 0.15s ease;
}

.td-btn--primary {
  background: var(--primary, #2563eb);
  color: #fff;
}

.td-btn:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.td-spinner {
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.35);
  border-top-color: #fff;
  border-radius: 50%;
  animation: td-spin 1s linear infinite;
}

.td-spinner--lg {
  width: 32px;
  height: 32px;
  border-width: 3px;
  border-color: var(--border);
  border-top-color: var(--primary, #2563eb);
}

@keyframes td-spin {
  to {
    transform: rotate(360deg);
  }
}

.td-dropzone {
  border: 2px dashed var(--border-strong, var(--border));
  border-radius: 8px;
  padding: 24px;
  text-align: center;
  background: var(--surface);
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
}

.td-dropzone--active {
  border-color: var(--primary, #2563eb);
  background: color-mix(in srgb, var(--primary, #2563eb) 8%, var(--surface));
}

.td-dropzone--busy {
  opacity: 0.6;
  cursor: not-allowed;
}

.td-dropzone__inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.td-dropzone__icon {
  color: var(--primary, #2563eb);
  opacity: 0.85;
}

.td-dropzone__title {
  margin: 0;
  font-weight: 600;
  color: var(--text-primary);
}

.td-dropzone__hint {
  margin: 4px 0 0;
  font-size: 0.85rem;
  color: var(--text-secondary);
}

.td-dropzone__formats,
.td-dropzone__accent {
  margin: 8px 0 0;
  font-size: 0.8rem;
  color: var(--text-secondary);
}

.td-dropzone__accent {
  color: var(--primary, #2563eb);
  font-weight: 500;
  font-size: 0.95rem;
}

.td-empty {
  text-align: center;
  padding: 40px 20px;
}

.td-empty--bordered {
  background: var(--surface);
  border-radius: 6px;
  border: 1px dashed var(--border);
}

.td-alert {
  padding: 12px 16px;
  border-radius: 6px;
  font-size: 0.9rem;
}

.td-alert--error {
  background: color-mix(in srgb, #dc3545 12%, var(--surface));
  border: 1px solid color-mix(in srgb, #dc3545 35%, var(--border));
  color: #f87171;
}

[data-theme="light"] .td-alert--error {
  color: #721c24;
}

.td-table-wrap {
  max-height: 400px;
  overflow: auto;
  border-radius: 6px;
  border: 1px solid var(--border);
  background: var(--surface);
}

.td-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
  color: var(--text-primary);
}

.td-table th {
  position: sticky;
  top: 0;
  z-index: 1;
  padding: 12px;
  text-align: left;
  font-weight: 600;
  color: var(--text-primary);
  background: var(--table-header, var(--bg-tertiary));
  border-bottom: 2px solid var(--border);
  min-width: 140px;
}

.td-table td {
  padding: 12px;
  color: var(--text-primary);
  border-bottom: 1px solid var(--border);
  word-break: break-word;
  min-width: 140px;
}

.td-row--even {
  background: var(--surface);
}

.td-row--odd {
  background: var(--bg-tertiary, var(--surface-hover));
}

.td-table tbody tr:hover {
  background: var(--table-hover, var(--surface-hover));
}

.td-input {
  width: 100%;
  padding: 8px;
  border: 1px solid var(--input-border, var(--border));
  border-radius: 4px;
  font-size: 0.9rem;
  font-family: inherit;
  box-sizing: border-box;
  background: var(--input-background, var(--surface));
  color: var(--text-primary);
}

.td-input--error {
  border-color: #dc3545;
  background: color-mix(in srgb, #dc3545 8%, var(--surface));
}

.td-field-error {
  display: block;
  margin-top: 4px;
  font-size: 0.75rem;
  color: #dc3545;
}

.rt-results-modal {
  background: var(--surface) !important;
  color: var(--text-primary);
  border: 1px solid var(--border);
}

.rt-results-modal .text-gray-900,
.rt-results-modal .text-gray-800 {
  color: var(--text-primary) !important;
}

.rt-results-modal .text-gray-600,
.rt-results-modal .text-gray-500,
.rt-results-modal .text-gray-400 {
  color: var(--text-secondary) !important;
}

.rt-results-modal .bg-gray-50,
.rt-results-modal .bg-gray-100,
.rt-results-modal .border-gray-200,
.rt-results-modal .border-gray-300 {
  background-color: var(--bg-tertiary, var(--surface-hover)) !important;
  border-color: var(--border) !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/rt2-entity.css"],"names":[],"mappings":"AAAA,kEAAkE;;AAElE,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,oBAAoB;EACpB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,mCAAmC;EACnC,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,oDAAoD;EACpD,aAAa;EACb,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,sBAAsB;EACtB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,sDAAsD;EACtD,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,qCAAqC;EACrC,0EAA0E;AAC5E;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;;EAEE,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,2DAA2D;EAC3D,gEAAgE;EAChE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,mDAAmD;EACnD,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,sCAAsC;EACtC,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,mDAAmD;EACnD,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,0DAA0D;AAC5D;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;;;EAGE,uCAAuC;AACzC;;AAEA;;;;EAIE,qEAAqE;EACrE,sCAAsC;AACxC","sourcesContent":["/* Test Case detail / Test Data / Reorder — theme-aware surfaces */\n\n/* Reorder lists */\n.rt-reorder-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.rt-reorder-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 14px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  cursor: grab;\n  color: var(--text-primary);\n}\n\n.rt-reorder-row:active {\n  cursor: grabbing;\n}\n\n.rt-reorder-handle {\n  color: var(--text-secondary);\n  letter-spacing: -2px;\n  font-size: 14px;\n  user-select: none;\n}\n\n.rt-reorder-row__title {\n  font-weight: 600;\n  font-size: 0.95rem;\n}\n\n.rt-reorder-row__meta {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  margin-top: 4px;\n  font-size: 0.8rem;\n  color: var(--text-secondary);\n}\n\n.rt-reorder-list .drop-indicator {\n  height: 3px;\n  background: var(--primary, #3b82f6);\n  border-radius: 2px;\n  margin: 2px 0;\n}\n\n.rt-reorder-list .dragging {\n  opacity: 0.55;\n}\n\n/* Test Data tab */\n.test-data-tab {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  color: var(--text-primary);\n}\n\n.td-section {\n  background: var(--bg-tertiary, var(--surface-hover));\n  padding: 16px;\n  border-radius: 10px;\n  border: 1px solid var(--border);\n}\n\n.td-section__row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.td-section__title {\n  margin: 0 0 4px;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.td-section__hint {\n  margin: 0;\n  font-size: 0.85rem;\n  color: var(--text-secondary);\n}\n\n.td-btn {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  transition: opacity 0.15s ease;\n}\n\n.td-btn--primary {\n  background: var(--primary, #2563eb);\n  color: #fff;\n}\n\n.td-btn:disabled {\n  cursor: not-allowed;\n  opacity: 0.55;\n}\n\n.td-spinner {\n  width: 14px;\n  height: 14px;\n  border: 2px solid rgba(255, 255, 255, 0.35);\n  border-top-color: #fff;\n  border-radius: 50%;\n  animation: td-spin 1s linear infinite;\n}\n\n.td-spinner--lg {\n  width: 32px;\n  height: 32px;\n  border-width: 3px;\n  border-color: var(--border);\n  border-top-color: var(--primary, #2563eb);\n}\n\n@keyframes td-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.td-dropzone {\n  border: 2px dashed var(--border-strong, var(--border));\n  border-radius: 8px;\n  padding: 24px;\n  text-align: center;\n  background: var(--surface);\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease;\n}\n\n.td-dropzone--active {\n  border-color: var(--primary, #2563eb);\n  background: color-mix(in srgb, var(--primary, #2563eb) 8%, var(--surface));\n}\n\n.td-dropzone--busy {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.td-dropzone__inner {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n}\n\n.td-dropzone__icon {\n  color: var(--primary, #2563eb);\n  opacity: 0.85;\n}\n\n.td-dropzone__title {\n  margin: 0;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.td-dropzone__hint {\n  margin: 4px 0 0;\n  font-size: 0.85rem;\n  color: var(--text-secondary);\n}\n\n.td-dropzone__formats,\n.td-dropzone__accent {\n  margin: 8px 0 0;\n  font-size: 0.8rem;\n  color: var(--text-secondary);\n}\n\n.td-dropzone__accent {\n  color: var(--primary, #2563eb);\n  font-weight: 500;\n  font-size: 0.95rem;\n}\n\n.td-empty {\n  text-align: center;\n  padding: 40px 20px;\n}\n\n.td-empty--bordered {\n  background: var(--surface);\n  border-radius: 6px;\n  border: 1px dashed var(--border);\n}\n\n.td-alert {\n  padding: 12px 16px;\n  border-radius: 6px;\n  font-size: 0.9rem;\n}\n\n.td-alert--error {\n  background: color-mix(in srgb, #dc3545 12%, var(--surface));\n  border: 1px solid color-mix(in srgb, #dc3545 35%, var(--border));\n  color: #f87171;\n}\n\n[data-theme=\"light\"] .td-alert--error {\n  color: #721c24;\n}\n\n.td-table-wrap {\n  max-height: 400px;\n  overflow: auto;\n  border-radius: 6px;\n  border: 1px solid var(--border);\n  background: var(--surface);\n}\n\n.td-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.9rem;\n  color: var(--text-primary);\n}\n\n.td-table th {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  padding: 12px;\n  text-align: left;\n  font-weight: 600;\n  color: var(--text-primary);\n  background: var(--table-header, var(--bg-tertiary));\n  border-bottom: 2px solid var(--border);\n  min-width: 140px;\n}\n\n.td-table td {\n  padding: 12px;\n  color: var(--text-primary);\n  border-bottom: 1px solid var(--border);\n  word-break: break-word;\n  min-width: 140px;\n}\n\n.td-row--even {\n  background: var(--surface);\n}\n\n.td-row--odd {\n  background: var(--bg-tertiary, var(--surface-hover));\n}\n\n.td-table tbody tr:hover {\n  background: var(--table-hover, var(--surface-hover));\n}\n\n.td-input {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid var(--input-border, var(--border));\n  border-radius: 4px;\n  font-size: 0.9rem;\n  font-family: inherit;\n  box-sizing: border-box;\n  background: var(--input-background, var(--surface));\n  color: var(--text-primary);\n}\n\n.td-input--error {\n  border-color: #dc3545;\n  background: color-mix(in srgb, #dc3545 8%, var(--surface));\n}\n\n.td-field-error {\n  display: block;\n  margin-top: 4px;\n  font-size: 0.75rem;\n  color: #dc3545;\n}\n\n.rt-results-modal {\n  background: var(--surface) !important;\n  color: var(--text-primary);\n  border: 1px solid var(--border);\n}\n\n.rt-results-modal .text-gray-900,\n.rt-results-modal .text-gray-800 {\n  color: var(--text-primary) !important;\n}\n\n.rt-results-modal .text-gray-600,\n.rt-results-modal .text-gray-500,\n.rt-results-modal .text-gray-400 {\n  color: var(--text-secondary) !important;\n}\n\n.rt-results-modal .bg-gray-50,\n.rt-results-modal .bg-gray-100,\n.rt-results-modal .border-gray-200,\n.rt-results-modal .border-gray-300 {\n  background-color: var(--bg-tertiary, var(--surface-hover)) !important;\n  border-color: var(--border) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
